import Loader from "./loader";

const loader = new Loader();

export const loadMap = async ({ container, options, config }) => {
  const {
    error,
    modules: [WebMap, MapView, ImageryLayer],
  } = await loader.load([
    "esri/WebMap",
    "esri/views/MapView",
    "esri/layers/ImageryLayer",
  ]);
  if (error) return { error };
  const webmapId = config.portalIds.anonymous;
  const serviceId = config.serviceIds.anonymous;

  let webmap = new WebMap({
    portalItem: {
      id: webmapId,
    },
  });
  const imageryLayer = new ImageryLayer({
    visible: true,
    portalItem: {
      // autocasts as new PortalItem()
      id: serviceId,
    },
  });
  if (!imageryLayer.loaded) await imageryLayer.load();
  // if (!webmap.loaded) await webmap.loadAll();

  let view = new MapView({
    map: webmap,
    container,
    layers: [imageryLayer],
    ...options,
  });
  return { webmap, view, imageryLayer };
};
